import {SupplementaryConfirmations} from './SupplementaryConfirmations';
import {SupplementaryGeneralDeclaration} from './SupplementaryGeneralDeclaration';

import type {SupplementaryDeclarationValues} from './fatca-crs-supplementary.types';
import type {FatcaCrsDeclarationDTO} from '@sollapay/types';
import type {FC, ReactNode} from 'react';
import type {Control, UseFormSetValue} from 'react-hook-form';

export interface FatcaCrsSupplementarySectionProps {
  /** The signed main (parent) declaration — supplies the signed date. Nullable while loading. */
  mainDeclaration?: FatcaCrsDeclarationDTO | null;
  /** Trustee / lawyer name shown in the signature confirmation text. */
  lawyerName?: string;
  control: Control<SupplementaryDeclarationValues>;
  setValue: UseFormSetValue<SupplementaryDeclarationValues>;
  /** Flow-specific beneficiary table region, rendered between the general declaration and the confirmations. */
  children?: ReactNode;
  disabled?: boolean;
}

/**
 * Layout shell for the supplementary FATCA/CRS declaration. Owns the parts shared by every flow —
 * the general declaration block and the confirmation/signature checkboxes — and slots the
 * flow-specific beneficiary tables in between via `children`.
 */
export const FatcaCrsSupplementarySection: FC<FatcaCrsSupplementarySectionProps> = ({
  mainDeclaration,
  lawyerName,
  control,
  setValue,
  children,
  disabled = false
}) => (
  <div className="flex flex-col gap-6" data-slot="fatca-crs-supplementary-section">
    <SupplementaryGeneralDeclaration signedAt={mainDeclaration?.signedAt} />
    {children}
    <SupplementaryConfirmations
      lawyerName={lawyerName}
      control={control}
      setValue={setValue}
      disabled={disabled}
    />
  </div>
);
